const messages = {
    en: {
        siteURL: "https://www.fineoglass.eu/",
        lang: "en",
        messages: {
            pageTitle: "Request a quote | FINEO",
            yes: "Yes",
            no: "No",
            back: "Back to Fineo",
            skip: "Skip this step",
            previous: "Previous",
            next: "Next",
            documents: {
                help: "Drop a file here or click to upload",
                info: "Maximum upload size: {size}",
            },
            breadcrumbs: {
                ask: "Ask for a quote",
                information: "Ask for more information",
                project: "Your project",
                details: "Your details",
            },
            countries: {
                be: "Belgium",
                de: "Germany",
                fr: "France",
                nl: "Netherlands",
                dk: "Denmark",
                ch: "Switzerland",
                lu: "Luxembourg",
                gb: "United Kingdom",
                ie: "Ireland",
                au: "Austria",
                it: "Italy",
                xx: "Other",
            },
            hearabouts: {
                first: "In specialized press",
                second: "Through social networks",
                third: "Through word of mouth",
                fourth: "Through the advices of a professional (architect, energy consultant, engineering office, …)",
                fifth: "On a fair",
                sixth: "On internet",
                seventh: "Other",
            },
            housings: {
                house: "Individual house",
                building: "Building",
            },
            locations: {
                ground: "On the ground floor",
                floor: "On the higher floor",
            },
            materials: {
                pvc: "Plastic (PVC)",
                alu: "Aluminium",
                wood: "Wood",
                metal: "Metal",
            },
            ages: {
                lessFive: "Less than 5 years",
                fiveToTen: "5 to 10 years",
                tenToTwenty: "10 to 20 years",
                moreTwenty: "Over 20 years",
                dontKnow: "I don't know",
            },
            steps: {
                requestType: {
                    title: "You need to:",
                    askForQuote: "Ask for a quote",
                    askForInformations: "Ask for more information",
                    unsupportedCountry: 'The FINEO service is not yet available in your region. Do not hesitate to contact us via "Ask for more information".',
                    yourQuoteRequestWithFineo: "Your quote request with <span>fineo</span>",
                    yourQuoteRequest: "Your quote request",
                    welcomeToFineo: "Welcome to <span>fineo</span>",
                    workWithFineo: "Work with fineo, experience expertise",
                    shareYourProject: "Let us know about your project.",
                    selectProfessional: "After reviewing your request and the details of your project, <span>fineo</span> will select the best professional.",
                    iAm: "I am",
                    company: "A company",
                    particular: "A private individual",
                    professionnal: "A professional",
                    backTo: "back",
                    step2: "step 2",
                },
                projectType: {
                    title: "Your project",
                    iHaveAProjectOf: "I have a project for",
                    newConstruction: "New construction",
                    renovation: "Renovation",
                    restoration: "Restoration",
                },
                replaceType: {
                    title: "In what condition are your current frames and how would you like to benefit from FINEO?",
                    replaceMyGlazing: "My frames seem in good condition. I would like to replace the glazing only.",
                    newWindows: "I would prefer to change my entire window because my frames are not/may not be in good condition.",

                    iNeed: "And I need", 
                    chassis: "Windows",
                    step1: "step 1",
                    step3: "step 3",
                },
                housingType: {
                    title: "What type of building is it?",
                },
                buildingAge: {
                    title: "From which period is your building?",
                },
                locations: {
                    title: "At which level are the windows located?",
                    description: "You can select several choices",
                },
                materials: {
                    title: "What material is your window frame made of?",
                    description: "You can select several materials",
                    withWindowChassisIn: "With window frames in",
                },
                windowAges: {
                    title: "How old are your windows?",
                    description: "You can select several ages",
                },
                glazingsCounters: {
                    title: "Which type of glazing do you currently have ?",
                    singleGlazing: "Single glazing",
                    doubleGlazing: "Double glazing",
                },
                newWindowsCounter: {
                    title: "How many windows do you wish to install?",
                    windows: "No windows | 1 window | {n} windows",
                },
                contactDetails: {
                    title: "Your details",
                    errors: "Please fill in or correct the fields in red",
                    errorsPhone: "Phone must have a minimum of 4 characters and a maximum of 15 characters",
                    errorPostCode: "Zip code must have a maximum of 5 characters, a minimum of 4 characters and grater than 0",
                    errorMessage: "Message must have a maximum of 1000 characters",
                    errorSpamMessage: "The content of your current message is considered as spam and will not be delivered to the team. Please review it before submitting.",
                    fileTooBig: "The file \"{filename}\" is too big.",
                    firstName: "First name*",
                    lastName: "Last name*",
                    email: "Email*",
                    or: "or",
                    apple: "Sign in with Apple",
                    facebook: "Sign in with Facebook",
                    google: "Sign in with Google",
                    address: "Address",
                    city: "City*",
                    postcode: "Postcode*",
                    country: "Country*",
                    phone: "Phone*",
                    optional: "optional",
                    message: "Message*",
                    hearabout: "How did you hear about Fineo?",
                    documents: "Upload an attachment<span>(max 200MB)</span>.",
                    optin: "Do you want to receive information from FINEO by email, SMS or letter",
                    legals: "By ticking YES, I agree to be contacted by FINEO for commercial prospecting purposes and to receive FINEO tips by email and only the best offers by SMS or postal mail. <br/> By ticking NO, my personal data will only be used for the purpose of executing my request.",
                    legals2: 'By clicking on "submit" you confirm that you have read the Fineo website\'s <a href="https://www.fineoglass.eu/legal-notice/">legal notice</> and <a href="https://www.fineoglass.eu/privacy-policy/">privacy policy</a>, and you consent to the use of your personal data for the purpose of executing your request.',
                    sendMyRequest: "Submit",
                    proceeding: "Loading...",
                    recaptcha: 'This site is portected by reCAPTCHA and the Google <a href="#">Privaciy policy</a> and <a href="#">Terms of Service</a> apply.',
                    incompleteFieldMessage: "Please fill in or correct this field",
                    incompleteMailMessage: "Incorrect email format",
                    incompletePhoneMessage: "Incorrect phone format",
                    placeholders: {
                        firstName: "your name",
                        lastName: "your first name",
                        phone: "phone number",
                        email: "your email address",
                        address: "your postal address",
                        city: "your city",
                        postcode: "your postal code",
                    },
                    popup: {
                        fineoThankYou: "Fineo thanks you!",
                        requestAccepted: "Your request has been processed",
                        backToWebsite: "Back to website",
                        youLlBeRedirected: "You will be redirected in <span data-timer>5</span> s",
                        processing: "Loading",
                        requestStatusInProgress: "Your request is being processed",
                        Error: "Error !",
                        requestFailed: "Failed to process your request! please try again later."
                    }
                },
                clientDetails: {
                    title: "Your details"
                }
            },
            informations: {
                intro: "Work with FINEO. Experience expertise.<br/><br/>Let us know what your project is about. After examining your request and project details, FINEO will select the best window professional to assist you. With the Fineo Certified installer, you benefit from solutions and advice from real experts. Our team is committed to offering you a professional and personalized service.",
                didYouKnow: 'Did you know?<br/><br/>You can change your glass window without changing window frames. Our glass panes can be elegantly retrofitted into any existing window frame, saving you time and money.<br/><br/>If you want to install Fineo in new windows, please refer to your architect or contractor to get more information about FINEO or complete the contact form by clicking on "Install new windows".',
                yourProject: "Your project details",
            },
            directContact: {
                or: "Or",
                contactByPhone: "Contact me by phone",
                selectMoment: "Select a moment",
                morning: "Morning",
                afternoon: "Afternoon",
                callMe: "Call me",
            },
            thankYou: {
                title: "Thank you",
                title2: "Thank you ! We will respond as soon as possible.",
            },
        },
    },
    fr: {
        siteURL: "https://www.fineoglass.eu/fr/",
        lang: "fr",
        messages: {
            pageTitle: "Demander un devis | FINEO",
            yes: "Oui",
            no: "Non",
            back: "Revenir à Fineo",
            skip: "Sautez cette étape",
            previous: "Précédent",
            next: "Suivant",
            documents: {
                help: "Déposer un fichier ici ou cliquer pour téléverser",
                info: "Taille de téléchargement maximum : {size}",
            },
            breadcrumbs: {
                ask: "Demander un devis",
                information: "Obtenir plus d'informations",
                project: "Votre projet",
                details: "Vos informations",
            },
            countries: {
                be: "Belgique",
                de: "Allemagne",
                fr: "France",
                nl: "Pays-Bas",
                dk: "Danemark",
                ch: "Suisse",
                lu: "Luxembourg",
                gb: "Royaume-unis",
                ie: "Irlande",
                au: "Autriche",
                it: "Italie",
                xx: "Autre",
            },
            hearabouts: {
                first: "Dans la presse spécialisée",
                second: "Via les réseaux sociaux",
                third: "Par le bouche à oreille",
                fourth: "Sur les conseils d’un professionnel (architecte, conseiller en énergie, bureau d’études, ...)",
                fifth: "Sur un salon",
                sixth: "Sur internet",
                seventh: "Autre",
            },
            housings: {
                house: "Maison individuelle",
                building: "Immeuble",
            },
            locations: {
                ground: "Au rez-de-chaussée",
                floor: "À l’étage",
            },
            materials: {
                pvc: "Plastique (PVC)",
                alu: "Aluminium",
                wood: "Bois",
                metal: "Metal",
            },
            ages: {
                lessFive: "Moins de 5 ans",
                fiveToTen: "5 à 10 ans",
                tenToTwenty: "10 à 20 ans",
                moreTwenty: "Plus de 20 ans",
                dontKnow: "Je ne sais pas",
            },
            steps: {
                requestType: {
                    title: "Vous souhaitez :",
                    askForQuote: "Demander un devis",
                    askForInformations: "Obtenir plus d'informations",
                    unsupportedCountry: "Le service FINEO n'est pas encore disponible dans votre région. N'hésitez pas à nous contacter via \"Obtenir plus d'informations\".",
                    yourQuoteRequestWithFineo: "Votre demande de devis avec <span>fineo</span>",
                    yourQuoteRequest: "Votre demande de devis",
                    welcomeToFineo: "Bienvenue chez <span>fineo</span>",
                    workWithFineo: "Travaillez avec fineo, faites l'experience de l'expertise",
                    shareYourProject: "Faites-nous part de votre projet.",
                    selectProfessional: "Après avoir examiné votre demande et les détails de votre projet, <span>fineo</span> sélectionnera le meilleur professionnel.",
                    iAm: "Je suis",
                    company: "Une entreprise",
                    particular: "Un particulier",
                    professionnal: "Un professionnel",
                    backTo: "retour",
                    step2: "étape 2",
                },
                projectType: {
                    title: "Votre projet",
                    iHaveAProjectOf: "J'ai un projet de",
                    newConstruction: "Nouvelle construction",
                    renovation: "Rénovation",
                    restoration: "Restauration",
                },
                replaceType: {
                    title: "Dans quel état sont vos montures actuelles et comment souhaitez-vous bénéficier de FINEO ?",
                    replaceMyGlazing: "Mes châssis semblent en bon état. Je voudrais remplacer uniquement le vitrage.",
                    newWindows: "Je préfère changer toute ma fenêtre car mes châssis ne sont pas/peuvent ne pas être en bon état.",

                    iNeed: "Et j'ai besoin de", 
                    chassis: "Fenêtres",
                    step1: "étape 1",
                    step3: "étape 3",
                },
                housingType: {
                    title: "Sur quel type de bâtiment souhaitez-vous changer vos fenêtres ?",
                },
                buildingAge: {
                    title: "De quelle période date votre bâtiment ?",
                },
                locations: {
                    title: "À quel niveau se trouvent les fenêtres ?",
                    description: "Vous pouvez sélectionner plusieurs choix",
                },
                materials: {
                    title: "De quoi est fait votre châssis de fenêtre ?",
                    description: "Vous pouvez sélectionner plusieurs matériaux",
                    withWindowChassisIn: "Avec des chassis de fenêtres en",
                },
                windowAges: {
                    title: "Quel âge ont vos fenêtres ?",
                    description: "Vous pouvez sélectionner plusieurs âges",
                },
                glazingsCounters: {
                    title: "Quel type de vitrage avez-vous actuellement ?",
                    singleGlazing: "Simple vitrage",
                    doubleGlazing: "Double vitrage",
                },
                newWindowsCounter: {
                    title: "Combien de fenêtres prévoyez-vous d'installer ?",
                    windows: "Aucune fenêtre | 1 fenêtre | {n} fenêtres",
                },
                contactDetails: {
                    title: "Vos informations",
                    errors: "Veuillez remplir ou corriger les champs en rouge",
                    errorsPhone: "Le numéro de téléphone doit avoir au minimum 4 caractères et au maximum 15 caractères",
                    errorPostCode: "Le code postal doit avoir un maximum de 5 caractères, un minimum de 4 caractères et plus de 0.",
                    errorMessage: "Le message doit avoir un maximum de 1000 caractères",
                    errorSpamMessage: "Le contenu de votre message est considéré comme indésirable et ne sera pas livré à l’équipe. Merci de le reviser avant de l’envoyer.",
                    fileTooBig: "Le fichier \"{filename}\" est trop volumineux.",
                    firstName: "Prénom*",
                    lastName: "Nom*",
                    email: "Email*",
                    or: "ou",
                    apple: "Se connecter avec Apple",
                    facebook: "Se connecter avec Facebook",
                    google: "Se connecter avec Google",
                    address: "Adresse",
                    city: "Ville*",
                    postcode: "Code postal*",
                    country: "Pays*",
                    phone: "Téléphone*",
                    optional: "optionnel",
                    message: "Message*",
                    hearabout: "Comment avez-vous connu Fineo?",
                    documents: "Téléchargez une pièce jointe<span>(max 200MB)</span>.",
                    optin: "Voulez-vous recevoir des informations de FINEO par e-mail, SMS ou lettre",
                    legals: "En cochant OUI, j’accepte d’être sollicité(e) par FINEO à des fins de prospection commerciale et de recevoir les bons plans FINEO par email et uniquement les meilleures offres par SMS ou courrier postal.<br/>En cochant NON, mes données personnelles ne seront utilisées que pour les besoins de l'exécution de ma demande.",
                    legals2: 'En cliquant sur « soumettre » vous confirmez avoir pris connaissance des <a href="https://www.fineoglass.eu/fr/mention-legale/">mentions légales</a> du site Fineo et de la <a href="https://www.fineoglass.eu/fr/Privee/">politique de confidentialité</a>, et vous consentez à l’utilisation de vos données personnelles pour les besoins de l’exécution de votre demande.',
                    sendMyRequest: "Soumettre",
                    proceeding: "Traitement",
                    yourCountry: "Votre Pays",
                    uploadAnAttachedFile: "Télécharger une pièce jointe",
                    maxSize: "(max 200MB)",
                    loading: "Loading",
                    recaptcha: 'Ce site est protégé par reCAPTCHA et les <a href="#">Privacy policy</a> et <a href="#">Terms of Service</a> de Google s\'appliquent.',
                    incompleteFieldMessage: "Veuillez remplir ou corriger ce champ",
                    incompleteMailMessage: "Format d'email incorrect",
                    incompletePhoneMessage: "Format de téléphone incorrect",
                    placeholders: {
                        firstName: "votre nom",
                        lastName: "votre prénom",
                        phone: "n° de téléphone",
                        email: "votre adresse email",
                        address: "votre adresse postal",
                        city: "votre ville",
                        postcode: "votre code postal",
                    },
                    popup: {
                        fineoThankYou: "Fineo vous remercie !",
                        requestAccepted: "Votre demande a bien été prise en compte",
                        backToWebsite: "Retourner au site",
                        youLlBeRedirected: "Vous allez être redirigé dans <span data-timer>5</span> s",
                        processing: "Chargement",
                        requestStatusInProgress: "Votre demande est cours de traitement",
                        Error: "Erreur !",
                        requestFailed: "Le traitement de votre demande a échoué! veuillez réessayer plus tard."
                    }
                },
                clientDetails: {
                    title: "Vos informations"
                }
            },
            informations: {
                intro: "Travaillez avec FINEO. Faites l'expérience de l'expertise.<br/><br/>Faites-nous part de votre projet. Après avoir examiné votre demande et les détails de votre projet, FINEO sélectionnera le meilleur professionnel de la fenêtre pour vous assister. Avec l'installateur certifié Fineo, vous bénéficiez de solutions et de conseils de véritables experts. Notre équipe s'engage à vous offrir un service professionnel et personnalisé.",
                didYouKnow: "Le saviez-vous ?<br/><br/>Vous pouvez changer vos vitres sans changer de châssis. Nos vitres peuvent être élégamment installées dans n'importe quel cadre de fenêtre existant, ce qui vous permet d'économiser du temps et de l'argent.<br/><br/>Si vous souhaitez installer Fineo dans de nouvelles fenêtres, veuillez vous adresser à votre architecte ou à votre entrepreneur pour obtenir plus d'informations sur FINEO ou remplir le formulaire de contact en cliquant sur « Installer de nouvelles fenêtres ».",
                details: "Informations sur votre projet",
            },
            directContact: {
                or: "Ou",
                contactByPhone: "Contactez moi par téléphone",
                selectMoment: "Sélectionnez un moment",
                morning: "Matin",
                afternoon: "Après-midi",
                callMe: "Appellez-moi",
            },
            thankYou: {
                title: "Merci",
                title2: "Merci ! Nous vous répondrons dans les plus brefs délais.",
            },
        },
    },
    de: {
        siteURL: "https://www.fineoglass.eu/de/",
        lang: "de",
        messages: {
            pageTitle: "Ein Angebot anfordern | FINEO",
            yes: "Ja",
            no: "Nein",
            back: "Zurück zu Fineo",
            skip: "Überspringe diesen Schritt",
            previous: "Bisherige",
            next: "Nächster",
            documents: {
                help: "Legen Sie eine Datei hier ab oder klicken Sie, um sie hochzuladen",
                info: " Maximale Größe einer Datei: {size}",
            },
            breadcrumbs: {
                ask: "Ein Angebot anfordern",
                information: "Frage nach mehr Infos",
                project: "Ihr Projekt",
                details: "Ihre Informationen",
            },
            countries: {
                be: "Belgien",
                de: "Deutschland",
                fr: "Frankreich",
                nl: "Niederlande",
                dk: "Dänemark",
                ch: "Schweiz",
                lu: "Luxemburg",
                gb: "Vereinigtes Königreich",
                ie: "Irland",
                au: "Österreich",
                it: "Italien",
                xx: "Andere",
            },
            hearabouts: {
                first: "In der Fachpresse",
                second: "Durch soziale Netzwerke",
                third: "Durch Mundpropaganda",
                fourth: "Durch den Rat eines Fachmanns (Architekt, Energieberater, Ingenieurbüro, ...)",
                fifth: "Auf einer Messe",
                sixth: "Im Internet",
                seventh: "Andere",
            },
            housings: {
                house: "Einzelhaus",
                building: "Gebäude",
            },
            locations: {
                ground: "Im Erdgeschoss",
                floor: "Auf einer höheren Etage",
            },
            materials: {
                pvc: "Kunststoff (PVC)",
                alu: "Aluminium",
                wood: "Holz",
                metal: "Metall",
            },
            ages: {
                lessFive: "Unter 5 Jahre",
                fiveToTen: "5 bis 10 Jahre",
                tenToTwenty: "10 bis 20 Jahre",
                moreTwenty: "Älter als 20 Jahre",
                dontKnow: "Ich weiß es nicht",
            },
            steps: {
                requestType: {
                    title: "Sie möchten:",
                    askForQuote: "Ein Angebot anfordern",
                    askForInformations: "Frage nach mehr Infos",
                    unsupportedCountry: 'Der FINEO-Service ist in Ihrer Region noch nicht verfügbar. Zögern Sie nicht, uns über "Frage nach mehr Infos" zu kontaktieren.',
                    yourQuoteRequestWithFineo: "Ihre Angebotsanfrage mit <span>fineo</span>",
                    yourQuoteRequest: "Ihre Anfrage für einen Kostenvoranschlag",
                    welcomeToFineo: "Willkommen bei <span>fineo</span>",
                    workWithFineo: "Arbeiten Sie mit fineo, erleben Sie Expertise",
                    shareYourProject: "Teilen Sie uns Ihr Projekt mit.",
                    selectProfessional: "Nachdem <span>fineo</span> Ihre Anfrage und die Details Ihres Projekts geprüft hat, wählt <span>den besten Fachmann aus.",
                    iAm: "Ich bin",
                    company: "Ein Unternehmen",
                    particular: "Eine Privatperson",
                    professionnal: "Eine Fachkraft",
                    backTo: "zurück",
                    step2: "Schritt 2",
                },
                projectType: {
                    title: "Ihr Projekt",
                    iHaveAProjectOf: "Ich habe ein Projekt von",
                    newConstruction: "Neue konstruktion",
                    renovation: "Renovierung",
                    restoration: "Wiederherstellung",
                },
                replaceType: {
                    title: "Wie ist der zustand ihrer aktuellen fensterrahmen und wie möchten sie von fineo profitieren?",
                    replaceMyGlazing: "Meine Fensterrahmen scheinen in gutem Zustand zu sein. Ich möchte nur die Verglasung austauschen.",
                    newWindows: "Ich ziehe es vor, mein gesamtes Fenster zu ersetzen, da meine Rahmen nicht in gutem Zustand sind/ sein können.",
                    
                    iNeed: "Und ich brauche", 
                    chassis: "Fenster",
                    step1: "Schritt 1",
                    step3: "Schritt 3",
                },
                housingType: {
                    title: "Welcher art ist das gebäude, in dem die fenster ausgetauscht werden sollen?",
                },
                buildingAge: {
                    title: "Aus welcher zeit stammt ihr gebäude?",
                },
                locations: {
                    title: "Auf welcher Etage befinden sich die Fenster?",
                    description: "Sie können mehrere Optionen auswählen",
                },
                materials: {
                    title: "Aus welchem material besteht ihr fensterrahmen?",
                    description: "Sie können mehrere Materialien auswählen",
                    withWindowChassisIn: "Mit Fensterrahmen aus",
                },
                windowAges: {
                    title: "Wie alt sind ihre fenster?",
                    description: "Sie können mehrere Altersstufen auswählen",
                },
                glazingsCounters: {
                    title: "Welche art von verglasung haben sie zurzeit?",
                    singleGlazing: "Einfachverglasung",
                    doubleGlazing: "Doppelverglasung",
                },
                newWindowsCounter: {
                    title: "Wie viele fenster wollen sie einbauen?",
                    windows: "Keine fenster | 1 fenster | {n} fenster",
                },
                contactDetails: {
                    title: "Ihre Informationen",
                    errors: "Bitte füllen Sie die roten Felder aus oder korrigieren Sie sie",
                    errorsPhone: "Die Telefonnummer muss mindestens 4 und darf höchstens 15 Zeichen lang sein.",
                    errorPostCode: "Die Postleitzahl darf maximal 5 Zeichen lang sein, mindestens 4 Zeichen und muss größer als 0 sein.",
                    errorMessage: "Die Nachricht darf maximal 1000 Zeichen lang sein.",
                    errorSpamMessage: "Der Inhalt Ihrer aktuellen Nachricht wird als Spam betrachtet und wird nicht an das Team weitergeleitet. Bitte überprüfen Sie ihn vor dem Absenden.",
                    fileTooBig: "Die Datei \"{filename}\" ist zu groß.",
                    firstName: "Vorname*",
                    lastName: "Name*",
                    email: "Email*",
                    or: "oder",
                    apple: "Mit Apple anmelden",
                    facebook: "Mit Facebook anmelden",
                    google: "Mit Google anmelden",
                    address: "Adresse",
                    city: "Stadt*",
                    postcode: "Postleitzahl*",
                    country: "Land*",
                    phone: "Telefon*",
                    optional: "Optional",
                    message: "Message*",
                    hearabout: "Wie haben Sie von Fineo erfahren?",
                    documents: "Laden Sie einen Anhang hoch<span>(max 200MB)</span>.",
                    optin: "Möchten Sie Informationen von FINEO per E-Mail, SMS oder Brief erhalten?",
                    legals: "Durch Aktivieren von JA erkläre ich mich damit einverstanden, von FINEO für kommerzielle Prospektionszwecke kontaktiert zu werden und FINEO-Tipps per E-Mail und nur die besten Angebote per SMS oder Post zu erhalten. <br/> Wenn Sie NEIN ankreuzen, werden meine persönlichen Daten nur zum Zweck der Ausführung meiner Anfrage verwendet.",
                    legals2: 'Mit dem Klick auf "Einreichen" bestätigen Sie, dass Sie die rechtlichen Hinweise und die <a href="https://www.fineoglass.eu/de/impressum/">Impressum</a> der Fineo-Website gelesen haben und stimmen der <a href="https://www.fineoglass.eu/de/privatsphare/">Verwendung Ihrer persönlichen Daten</a> zum Zwecke der Ausführung Ihrer Anfrage zu.',
                    sendMyRequest: "Einreichen",
                    proceeding: "Verfahren",
                    recaptcha: 'Diese Seite ist durch reCAPTCHA geschützt und es gelten die Google <a href="#">Datenschutzbestimmungen</a> und <a href="#">Dienstleistungsbedingungen</a>.',
                    incompleteFieldMessage: "Bitte füllen Sie dieses Feld aus oder korrigieren Sie es",
                    incompleteMailMessage: "Falsches E-Mail-Format",
                    incompletePhoneMessage: "Falsches Telefonformat",
                    placeholders: {
                        lastName: "Ihr Name",
                        firstName: "Ihr Vorname",
                        phone: "Telefon-Nr.",
                        email: "Ihre E-Mail-Adresse",
                        address: "Ihre Postanschrift",
                        city: "Ihre Stadt",
                        postcode: "Ihre Postleitzahl",
                    },
                    popup: {
                        fineoThankYou: "Fineo bedankt sich bei Ihnen!",
                        requestAccepted: "Ihre Anfrage wurde berücksichtigt.",
                        backToWebsite: "Zurück zur Website",
                        youLlBeRedirected: "Sie werden in <span data-timer>5</span> s weitergeleitet",
                        processing: "Laden",
                        requestStatusInProgress: "Ihr Antrag wird bearbeitet",
                        Error: "Error !",
                        requestFailed: "Die Bearbeitung Ihrer Anfrage ist fehlgeschlagen! Bitte versuchen Sie es später noch einmal."
                    }
                },
                clientDetails: {
                    title: "Ihre Informationen"
                }
            },
            informations: {
                intro: "Arbeiten Sie mit FINEO. Erleben Sie die Kompetenz.<br/><br/>Erzählen Sie uns von Ihrem Projekt. Nach Prüfung Ihrer Anfrage und Projektdetails wählt FINEO den besten Fensterprofi für Sie aus. Mit einem Fineo Certified Installer erhalten Sie Lösungen und Beratung von echten Experten. Unser Team ist bestrebt, Ihnen einen professionellen und persönlichen Service zu bieten.",
                didYouKnow: 'Haben Sie das gewusst?<br/><br/>Sie können Ihre Fenster austauschen, ohne den Rahmen zu verändern. Unser Glas lässt sich elegant in jeden bestehenden Fensterrahmen einbauen, was Ihnen Zeit und Geld spart.</br></br>Wenn Sie am Einbau von Fineo in neue Fenster interessiert sind, wenden Sie sich bitte an Ihren Architekten oder Bauunternehmer um weitere Informationen über FINEO zu erhalten oder füllen Sie das Kontaktformular aus indem Sie auf "Einbau neuer Fenster" klicken.',
                details: "Einzelheiten Ihres Projekts",
            },
            directContact: {
                or: "oder",
                contactByPhone: "Kontaktieren Sie mich telefonisch",
                selectMoment: "Wählen Sie einen Moment",
                morning: "Morgen",
                afternoon: "Nachmittag",
                callMe: "Ruf mich an",
            },
            thankYou: {
                title: "Vielen Dank",
                title2: "Vielen Dank ! Wir werden so schnell wie möglich antworten.",
            },
        },
    },
    nl: {
        siteURL: "https://www.fineoglass.eu/nl/",
        lang: "nl",
        messages: {
            pageTitle: "Een offerte aanvragen | FINEO",
            yes: "Ja",
            no: "Nee",
            back: "Terug naar Fineo",
            skip: "Sla deze stap over",
            previous: "Vorige",
            next: "Volgende",
            documents: {
                help: "Zet hier bestanden neer of klik om te uploaden",
                info: " Maximale uploadgrootte: {size}",
            },
            breadcrumbs: {
                ask: "Een offerte aanvragen",
                information: "Meer informatie krijgen",
                project: "Uw project",
                details: "Uw informatie",
            },
            countries: {
                be: "België",
                de: "Duitsland",
                fr: "Frankrijk",
                nl: "Nederland",
                dk: "Denemarken",
                ch: "Zwitserland",
                lu: "Luxemburg",
                gb: "Verenigd Koninkrijk",
                ie: "Ierland",
                au: "Oostenrijk",
                it: "Italië",
                xx: "Anders",
            },
            hearabouts: {
                first: "In de vakpers",
                second: "Via sociale netwerken",
                third: "Via mond-tot-mondreclame",
                fourth: "Via het advies van een professional (architect, energieconsulent, ingenieursbureau, ...)",
                fifth: "Op een beurs",
                sixth: "Op het internet",
                seventh: "Andere",
            },
            housings: {
                house: "Afzonderlijk huis",
                building: "Gebouw",
            },
            locations: {
                ground: "Op de benedenverdieping",
                floor: "Op bovenverdiepingen",
            },
            materials: {
                pvc: "Plastic (PVC)",
                alu: "Aluminium",
                wood: "Hout",
                metal: "Metaal",
            },
            ages: {
                lessFive: "Minder dan 5 jaar",
                fiveToTen: "5 tot 10 jaar",
                tenToTwenty: "10 tot 20 jaar",
                moreTwenty: "Meer dan 20 jaar",
                dontKnow: "Ik weet het niet",
            },
            steps: {
                requestType: {
                    title: "U wil:",
                    askForQuote: "Een offerte aanvragen",
                    askForInformations: "Meer informatie krijgen",
                    unsupportedCountry: 'De FINEO-service is nog niet beschikbaar in uw regio. Aarzel niet om contact met ons op te nemen via "Meer informatie krijgen".',
                    yourQuoteRequestWithFineo: "Uw offerteaanvraag bij <span>fineo</span>",
                    yourQuoteRequest: "Uw aanvraag voor een kostenraming",
                    welcomeToFineo: "Welkom bij <span>fineo</span>",
                    workWithFineo: "Werken met fineo, ervaringsdeskundigheid",
                    shareYourProject: "Vertel ons over je project.",
                    selectProfessional: "Nachdem <span>fineo</span> Ihre Anfrage und die Details Ihres Projekts geprüft hat, wählt <span>den besten Fachmann aus.",
                    iAm: "Ik ben",
                    company: "Een bedrijf",
                    particular: "Een particulier",
                    professionnal: "Een specialist",
                    backTo: "terug",
                    step2: "fase 2",
                },
                projectType: {
                    title: "Uw project",
                    iHaveAProjectOf: "Ik heb een",
                    newConstruction: "Nieuwbouw",
                    renovation: "Renovatie",
                    restoration: "Restauratie",
                },
                replaceType: {
                    title: "Wat is de conditie van uw huidige kozijnen en hoe wilt u profiteren van fineo?",
                    replaceMyGlazing: "Mijn kozijnen lijken in goede staat te zijn. Ik wil alleen de beglazing vervangen.",
                    newWindows: "Ik geef er de voorkeur aan mijn hele raam te vervangen, aangezien mijn kozijnen niet/misschien niet in goede staat zijn.",

                    iNeed: "En ik heb", 
                    chassis: "ramen",
                    step1: "fase 1",
                    step3: "fase 3",
                },
                housingType: {
                    title: "Wat soort woning is het gebouw waar de ramen moeten worden vervangen?",
                },
                buildingAge: {
                    title: "Uit welke periode dateert uw gebouw?",
                },
                locations: {
                    title: "Op welke verdieping bevinden de ramen zich?",
                    description: "U kunt verschillende keuzes maken",
                },
                materials: {
                    title: "uit welk materiaal bestaat uw raamkozijn?",
                    description: "U kunt verschillende materialen selecteren",
                    withWindowChassisIn: "Met kozijnen in",
                },
                windowAges: {
                    title: "Hoe oud zijn uw ramen?",
                    description: "U kunt verschillende leeftijden selecteren",
                },
                glazingsCounters: {
                    title: "Over welk soort beglazing Beschikt u Momenteel?",
                    singleGlazing: "Enkele beglazing",
                    doubleGlazing: "Dubbele beglazing",
                },
                newWindowsCounter: {
                    title: "Hoeveel ramen bent u van plan te installeren?",
                    windows: "Geen ramen | 1 ramen | {n} ramen",
                },
                contactDetails: {
                    title: "Uw informatie",
                    errors: "Vul de velden in of corrigeer deze rood",
                    errorsPhone: "Telefoon moet minimaal 4 en maximaal 15 tekens bevatten.",
                    errorPostCode: "De postcode mag maximaal 5 tekens bevatten, minimaal 4 tekens en groter dan 0.",
                    errorMessage: "Het bericht mag maximaal 1000 tekens lang zijn.",
                    errorSpamMessage: "De inhoud van uw huidige bericht wordt beschouwd als spam en zal niet worden afgeleverd bij het team. Controleer het voordat u het verstuurt.",
                    fileTooBig: "Het bestand \"{filename}\" is te groot.",
                    firstName: "Voornaam*",
                    lastName: "Achternaam*",
                    email: "Email*",
                    or: "of",
                    apple: "Inloggen met Apple",
                    facebook: "Inloggen met Facebook",
                    google: "Inloggen met Google",
                    address: "Adres",
                    city: "Stad*",
                    postcode: "Postcode*",
                    country: "Land*",
                    phone: "Telefoon*",
                    optional: "optioneel",
                    message: "Bericht*",
                    hearabout: "Hoe heeft u van Fineo gehoord?",
                    documents: "Upload een bijlage<span>(max 200MB)</span>.",
                    optin: "Wilt u informatie van FINEO ontvangen per e-mail, sms of brief",
                    legals: "Door JA aan te vinken, stem ik ermee in contact met FINEO op te nemen voor commerciële prospectiedoeleinden en FINEO-tips per e-mail en alleen de beste aanbiedingen per sms of post te ontvangen. <br/> Door NEE aan te vinken, mijn gegevens worden alleen gebruikt voor de uitvoering van het contract of precontractuele maatregelen.",
                    legals2: 'Door te klikken op "verzenden" bevestigt u dat u de <a href="https://www.fineoglass.eu/nl/juridische-kennisgeving/">juridische kennisgeving</a> en het <a href="https://www.fineoglass.eu/nl/privacy/">privacybeleid</a> van de website van Fineo hebt gelezen en dat u instemt met het gebruik van uw persoonsgegevens voor de uitvoering van uw verzoek.',
                    sendMyRequest: "Stuur mijn verzoek in",
                    proceeding: "Procedure",
                    recaptcha: 'Deze site is beveiligd door reCAPTCHA en het Google <a href="#">Privacybeleid</a> en <a href="#">Servicevoorwaarden</a> zijn van toepassing.',
                    incompleteFieldMessage: "Vul dit veld in of corrigeer het",
                    incompleteMailMessage: "Onjuist e-mailformaat",
                    incompletePhoneMessage: "Onjuist telefoonformaat",
                    placeholders: {
                        lastName: "uw achternaam",
                        firstName: "telefoonnummer",
                        phone: "n° de téléphone",
                        email: "uw e-mailadres",
                        address: "uw postadres",
                        city: "uw stad",
                        postcode: "uw postcode",
                    },
                    popup: {
                        fineoThankYou: "Fineo bedankt je!",
                        requestAccepted: "Uw verzoek is verzoekt",
                        backToWebsite: "Terug naar website",
                        youLlBeRedirected: "Je wordt doorgestuurd in <span data-timer>5</span> s",
                        processing: "Laden",
                        requestStatusInProgress: "Uw verzoek wordt verwerkt",
                        Error: "Fout",
                        requestFailed: "Uw aanvraag is niet verwerkt! Probeer het later nog eens."
                    }
                },
                clientDetails: {
                    title: "Uw informatie"
                }
            },
            informations: {
                intro: "Werk samen met FINEO. Ervaar de deskundigheid.<br/><br/>Vertel ons over je project. Na het bekijken van uw aanvraag en projectdetails zal FINEO de beste raamprofessional selecteren om u te helpen. Met een Fineo gecertificeerde installateur krijgt u oplossingen en advies van echte experts. Ons team is toegewijd om u een professionele en persoonlijke service te bieden.",
                didYouKnow: 'Wist je dat?<br/><br/>U kunt uw glas vervangen zonder het kozijn te veranderen. Ons glas kan elegant worden geïnstalleerd in elk bestaand raamkozijn, waardoor u tijd en geld bespaart.<br/><br/>Als u geïnteresseerd bent in het installeren van Fineo in nieuwe ramen, neem dan contact op met uw architect of aannemer voor meer informatie over FINEO of vul het contactformulier in door te klikken op "Nieuwe ramen installeren".',
                details: "Details van uw project",
            },
            directContact: {
                or: "Of",
                contactByPhone: "Neem telefonisch contact met me op",
                selectMoment: "Selecteer een moment",
                morning: "Ochtend",
                afternoon: "Middag",
                callMe: "Bel me",
            },
            thankYou: {
                title: "Dank je",
                title2: "Dank je ! We zullen zo snel mogelijk reageren.",
            },
        },
    },
};
